<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dark: {
      type: Boolean,
      default: false
    },
    stack: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            boxWidth: 12,
            boxBorderColor: null,
            fontStyle: "normal",
            fontFamily: "'Open Sans', sans-serif",
            fontColor: this.darkLight()
          }
        },
        events: [],
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          xAxes: [
            {
              // type: "linear",
              offset: true,
              beginAtZero: true,
              scaleLabel: {
                display: true,
                labelString: "Hours of the day",
                fontFamily: "'Open Sans', sans-serif",
                fontSize: 16,
                fontStyle: "bold",
                fontColor: this.darkLight()
              },
              gridLines: {
                color: this.darkLight(),
                zeroLineColor: this.darkLight(),
                drawOnChartArea: false,
                tickMarkLength: 4
              },
              ticks: {
                min: 0,
                max: 23,
                maxRotation: 0,
                stepSize: 1,
                padding: 4,
                callback: function(dataLabel, index) {
                  // Hide 24
                  if (index === 24) {
                    return "";
                  }
                  // Show only labels divisible by 6 (and 0)
                  return index % 6 === 0 ? dataLabel : "";
                },
                fontColor: this.darkLight()
              }
            }
          ],
          yAxes: [
            {
              display: false,
              stacked: this.stack,
              // type: "linear",
              beginAtZero: true,
              scaleLabel: {
                display: true,
                labelString: "Hits",
                fontFamily: "'Open Sans', sans-serif",
                fontSize: 16,
                fontStyle: "bold",
                fontColor: this.darkLight()
              },
              gridLines: {
                color: this.darkLight(),
                zeroLineColor: this.darkLight(),
                drawOnChartArea: false,
                drawBorder: false,
                tickMarkLength: 4
              },
              ticks: {
                // padding: 8,
                min: 0,
                // max: 5,
                stepSize: 1,
                mirror: true,
                // Include a dollar sign in the ticks
                callback: function(value /*, index, values*/) {
                  return value + "%";
                },
                fontColor: this.darkLight()
              }
            }
          ]
        },
        elements: {
          line: {
            fill: null,
            borderWidth: 1,
            borderColor: this.darkLight()
          },
          point: {
            pointStyle: "rect",
            borderWidth: 2
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  methods: {
    darkLight() {
      if (this.dark) {
        return "#FFFFFF";
      } else {
        return "#000000";
      }
    }
  }
};
</script>
